import { useSelector } from 'react-redux';
import { selectCurrentUserPermissions } from '@features/auth/store/selectors';
import { PERMISSIONS } from '@app/permissions/permissions';

export const useHasPermission = (permission: PERMISSIONS) => {
    const userPermissions: PERMISSIONS[] = useSelector(selectCurrentUserPermissions);

    if (!permission) {
        return false;
    }

    if (Array.isArray(permission)) {
        return permission.some((perm) => userPermissions.includes(perm));
    }

    return userPermissions.includes(permission);
};
